import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-search-icon',
  templateUrl: 'search-icon.component.html'
})
export class SearchIconComponent {
  constructor() {}
}
